import React from 'react';
import { motion } from 'framer-motion';

const Preloader = () => {
    const [count, setCount] = React.useState(0);

    React.useEffect(() => {
        const duration = 2500; // Slightly longer for smoothness
        const startTime = Date.now();

        // Quintic easing for that "jump then smooth landing" feel
        const easeOutQuart = (x) => 1 - Math.pow(1 - x, 4);

        const updateCounter = () => {
            const elapsedTime = Date.now() - startTime;
            const rawProgress = Math.min(elapsedTime / duration, 1);

            // Apply easing
            const easeProgress = easeOutQuart(rawProgress);

            const currentCount = Math.floor(easeProgress * 100);

            setCount(currentCount);

            if (rawProgress < 1) {
                requestAnimationFrame(updateCounter);
            }
        };

        requestAnimationFrame(updateCounter);
    }, []);

    // Helper to pad numbers < 10 with a leading zero (00, 05, 10...)
    // But since user asked "00" specifically, we might want 00..99
    // Actually, usually "0" -> "100". But "00" styling is cool.
    const displayCount = count === 100 ? "100" : String(count).padStart(2, "0");

    return (
        <motion.div
            className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center font-migra text-[#fbfbf4]"
            exit={{ y: "-100%", transition: { duration: 0.8, ease: [0.76, 0, 0.24, 1] } }}
        >
            <div className="relative overflow-hidden p-4">
                <span className="block text-[15vw] md:text-[20vw] leading-[0.8]">
                    {displayCount}
                </span>
            </div>
        </motion.div>
    );
};

export default Preloader;
